import castPetKiwi from "../../../assets/castPetKiwi.png";
import castPetDoggerino from "../../../assets/castPetDoggerino.png";
import { Image, Button, Icon } from "../../../atoms/components";
import { Link } from "react-router-dom";

export interface NotMemberUserProps {}

export function NotMemberUser({}: NotMemberUserProps) {
  const petImages = [castPetDoggerino, castPetKiwi];
  const randomImage = () => {
    return petImages[Math.floor(Math.random() * petImages.length)];
  };

  return (
    <div className="z-50 flex flex-col items-center my-auto">
      <Image src={randomImage()} className="w-40 max-h-[500px] mb-5" />

      <h1 className="mb-4 text-3xl font-bold text-primary-500">
        Account Unknown
      </h1>
      <p className="px-2 py-1 mb-4 rounded bg-error-100 text-error-600">
        <Icon name="error" /> You do not have permission to access this Cast
      </p>

      <p className="mb-4">Please contact your Administrator</p>

      {/* UI Purposes */}
      <Link to={"/logout"} className="mx-auto">
        <Button>LOG OUT</Button>
      </Link>
    </div>
  );
}
